module.exports = __webpack_public_path__ + "img/y-77.faf7af8f.png";